import { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import Recorder from "recorder-core";
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
import "recorder-core/src/engine/wav";
import "./AudioRecorder.less"
import usePlaySound from "@/hook/usePlaySound.tsx"
import { useTranslation } from "react-i18next";

let rec: any, recBlob: any, wave: any;
const AudioRecorder = forwardRef((props: any, ref) => {
    const { t } = useTranslation();
    const { sendAudio } = props
    const [recwave, setRecwave] = useState(null);
    const closePlaySound = usePlaySound('close')
    const [recordingdevice, setRecordingdevice] = useState(false);
    const [vicestep, setVicestep] = useState(1);
    const [voicebase64, setVoicebase64] = useState("");
    const audioRef: any = useRef<HTMLAudioElement>();
    const [voicePath, setVoicePath] = useState("");
    const [durations, setDurations] = useState(0);

    const [playing, setPlaying] = useState(false)

    const [voicesize, setVoicesize] = useState("");

    // 录音实例
    function recOpen() {
        // 创建录音对象
        rec = Recorder({
            type: "wav", // 录音格式，可以换成wav等其他格式
            sampleRate: 16000, // 录音的采样率，越大细节越丰富越细腻
            bitRate: 16, // 录音的比特率，越大音质越好
            onProcess: (
                buffers: any,
                powerLevel: any,
                bufferDuration: any,
                bufferSampleRate: any,
                newBufferIdx: any,
                asyncEnd: any
            ) => {
                // 录音实时回调，大约1秒调用12次本回调
                // 可实时绘制波形，实时上传（发送）数据
                if (wave) {
                    wave.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate);
                }
            },
        });
        console.log(rec)
        if (!rec) {
            return;
        }
        // 打开录音，获得权限
        rec.open(
            () => {
                if (recwave) {
                    // 创建音频可视化图形绘制对象
                    wave = Recorder.WaveView({ elem: recwave });
                }
            },
            (msg: string, isUserNotAllow: any) => { }
        );
        console.log(rec)
    }

    function openrecordingdevice() {
        setRecordingdevice(true)
        recOpen();
    }

    useEffect(() => {
        openrecordingdevice()
    }, [])

    function closerecordingdevice() {
        setRecordingdevice(false)
        deleteRecord();
        rec.close();
    }
    function deleteRecord() {
        recBlob = "";
        setVicestep(1)
        setDurations(0)
        setVoicebase64("")
        setPlaying(false);

    }
    function upload(blob: any) {
        blobToBase64(blob).then((res: any) => {
            setVoicebase64(res.match(/,(\S*)/)[1]);
        });
    }
    function blobToBase64(blob: any) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                resolve(e.target!.result);
            };
            fileReader.readAsDataURL(blob);
            fileReader.onerror = () => {
                reject(new Error("blobToBase64 error"));
            };
        });
    }

    function onEnded() {
        setPlaying(false)
    }
    // 本地播放录音
    function recPlay(url: any) {
        if (!url) { return false }
        if (voicesize !== url.size) {
            setVoicesize(url.size)
            const localUrl = URL.createObjectURL(url);
            setVoicePath(localUrl)
            setPlaying(true);
            setTimeout(() => {
                audioRef!.current!.currentTime = 0;
                audioRef!.current!.play(); // 这样就能播放了
            })


            return;
        }
        // 本地播放录音试听，可以直接用URL把blob转换成本地播放地址，用audio进行播放
        if (audioRef!.current) {
            if (audioRef!.current.paused) {
                setPlaying(true)
                audioRef!.current.currentTime = 0;
                audioRef!.current.play(); // 这样就能播放了

            } else {
                setPlaying(false)
                audioRef.current.pause(); // 这样就能播放了

            }
        }

    }


    // 开始录音
    function recStart() {
        console.log(rec)
        if (!rec) {
            return;
        }
        rec.start();
    }
    // 结束录音
    function recStop() {
        console.log(rec)
        if (!rec) {
            return;
        }
        rec.stop(
            (blob: any, duration: number) => {
                console.log(blob)
                recBlob = blob;
                const localUrl = (window.URL || window.webkitURL).createObjectURL(blob);
                // durations.value = 
                setDurations(Math.ceil(duration / 1000))
                upload(blob); // 把blob文件上传到服务器
            },
            (err: any) => { }
        );
    }
    function recStartStop() {

        if (vicestep == 1) {
            recStart();
            setVicestep(2)
            // vicestep.value++;
        } else if (vicestep == 2) {
            setVicestep(3)
            recStop();
        } else {
            console.log(recBlob)
            recPlay(recBlob);
        }
    }

    useImperativeHandle(ref, () => {
        return {
            deleteRecord,
            openrecordingdevice,
            closerecordingdevice


        }
    })


    //发送语音
    const sendAudioHandle = () => {
        const audioObj = {
            base64String: voicebase64,
            audio: voicePath,
            durations,

        }
        closePlaySound()
        sendAudio(audioObj);
        // rec.close();
    }



    return (
        <div className="w-full h-52  flex flex-col items-center justify-evenly box-border">
            <div className="start w-full h-full flex flex-col justify-center items-center mt-[50px]">
                {!playing && vicestep == 1 && (
                    <>

                        {/* <img onClick={() => recStartStop()} className="w-[70px] h-[70px]" src={startImg} alt="" /> */}
                        <svg onClick={() => recStartStop()} width="70px" height="70px" viewBox="0 0 70 70" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                            <defs>
                                <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                                    <stop stopColor="#00E49F" offset="0%"></stop>
                                    <stop stopColor="#54ADFF" offset="100%"></stop>
                                </linearGradient>
                            </defs>
                            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="02-talk语音" transform="translate(-153.000000, -329.000000)">
                                    <g id="编组-25备份-3" transform="translate(153.000000, 329.000000)">
                                        <circle id="椭圆形" fill="url(#linearGradient-1)" cx="35" cy="35" r="35"></circle>
                                        <g id="编组" transform="translate(21.250000, 15.000000)" fill="#FFFFFF" fillRule="nonzero">
                                            <path d="M26.1323851,13.9095783 C25.3770723,13.9095783 24.7647702,14.5474856 24.7647702,15.3343841 L24.7647702,19.4036297 C24.7647702,25.1598454 19.8222101,29.8417575 13.75,29.8417575 C7.67778993,29.8417575 2.73522976,25.1569958 2.73522976,19.4036297 L2.73522976,15.1748059 C2.73522976,14.3879073 2.12292772,13.75 1.36761488,13.75 C0.612302038,13.75 0,14.3879073 0,15.1748059 L0,19.4036297 C0,26.4336219 5.69474836,32.1470934 12.8501094,32.6030313 L12.8501094,37.5670549 L7.15262582,37.5670549 C6.46334792,37.5670549 5.90536105,38.205368 5.90536105,38.9947104 C5.90536105,39.7812032 6.46334792,40.4166667 7.15262582,40.4166667 L20.7877462,40.4166667 C21.4742888,40.4166667 22.0350109,39.7812032 22.0350109,38.9947104 C22.0350109,38.205368 21.4742888,37.5670549 20.7877462,37.5670549 L15.5853392,37.5670549 L15.5853392,32.5146933 C22.2948578,31.6341633 27.5,26.1258638 27.5,19.4036297 L27.5,15.3343841 C27.5,14.5450417 26.8900438,13.9095783 26.1323851,13.9095783 Z" id="路径"></path>
                                            <path d="M22.5044032,17.9562658 L22.5044032,8.7104009 C22.5044032,2.47280839 17.9872314,0.00617441674 13.3668714,0 C8.74738679,0.00618118691 5.00445228,3.9027942 5,8.7104009 L5,17.9562658 C5.00445228,22.7638725 8.74738679,26.6604855 13.3668714,26.6666667 C17.9878455,26.6620331 22.5044032,23.8109886 22.5044032,17.9562658 Z" id="路径"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>

                        <h2 className="text-sm text-[#333] m-3">{t("components.other.clickAndSpeak")}</h2>
                    </>

                )}

                {(!playing && vicestep == 2) && (
                    <>
                        <div onClick={() => recStartStop()} className="w-[70px] h-[70px] border bg-gradient-to-r from-[#57FF3D] to-[#54ADFF] flex justify-center items-center rounded-full">
                            <div className="loading"></div>
                        </div>


                        <h2 className="text-sm text-[#333] m-3">{t("components.other.stop")}</h2>

                    </>

                )}


                {vicestep == 3 ? (
                    <>
                        <div className="flex flex-col items-center justify-center" onClick={() => { closePlaySound(), recStartStop() }}>
                            <svg width="56px" height="56px" viewBox="0 0 56 56" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <defs>
                                    <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                                        <stop stopColor="#00E49F" offset="0%"></stop>
                                        <stop stopColor="#54ADFF" offset="100%"></stop>
                                    </linearGradient>
                                </defs>
                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="02-talk语音3" transform="translate(-160.000000, -301.000000)">
                                        <g id="编组-11" transform="translate(160.000000, 301.000000)">
                                            <circle id="椭圆形" fill="url(#linearGradient-1)" cx="28" cy="28" r="28"></circle>
                                            <g id="编组" transform="translate(11.000000, 11.000000)" fill="#FFFFFF" fillRule="nonzero">
                                                <path d="M17,34 C7.61108434,34 0,26.3889157 0,17 C0,7.61108434 7.61108434,0 17,0 C26.3889157,0 34,7.61108434 34,17 C34,26.3889157 26.3889157,34 17,34 Z M17.0983133,30.9154217 C24.7257831,30.9154217 30.9113253,24.7298795 30.9113253,17.1024096 C30.9113253,9.47493976 24.7257831,3.28939759 17.0983133,3.28939759 C9.47084337,3.28939759 3.2853012,9.47493976 3.2853012,17.1024096 C3.2853012,24.7298795 9.47084337,30.9154217 17.0983133,30.9154217 L17.0983133,30.9154217 Z M14.3209639,10.4908434 L23.8983133,16.0987952 C24.4021687,16.3978313 24.5742169,17.0491566 24.2751807,17.553012 C24.1809639,17.7086747 24.0498795,17.839759 23.8942169,17.9339759 L14.3209639,23.5009639 C13.813012,23.7959036 13.1616867,23.6238554 12.866747,23.12 C12.7725301,22.9561446 12.7233735,22.7718072 12.7233735,22.5833735 L12.7233735,11.4043373 C12.7233735,10.8185542 13.1985542,10.3433735 13.7884337,10.3433735 C13.9727711,10.3433735 14.1571084,10.3925301 14.3209639,10.4908434 Z" id="形状"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <audio src={voicePath} hidden={true} ref={audioRef}></audio>

                            <h2 className="text-sm text-[#333] m-3">{t("components.other.play")}</h2>
                        </div>
                        <div className="setting flex justify-around w-full">
                            <svg onClick={() => { closePlaySound(), deleteRecord() }} width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="02-talk语音3" transform="translate(-81.000000, -415.000000)">
                                        <g id="编组-12" transform="translate(81.000000, 415.000000)">
                                            <circle id="椭圆形备份-2" fillOpacity="0.4980059" fill="#7F7F7F" cx="25" cy="25" r="25"></circle>
                                            <g id="编组" transform="translate(13.333333, 12.500000)" fill="#FFFFFF" fillRule="nonzero">
                                                <path d="M4.58301589,20.6601299 L4.57917852,20.5275382 C4.57917852,20.572718 4.58071339,20.6167357 4.58301589,20.6601299 Z M14.4966562,5.5462053 C13.8841745,5.5462053 13.387626,6.04230463 13.387626,6.65543501 L13.3979129,20.5643566 C13.3979129,21.1764099 13.8944614,21.6736146 14.5069431,21.6736146 C15.1194248,21.6736146 15.6160017,21.1764099 15.6160017,20.5643566 L15.6062816,6.65543501 C15.6062816,6.04233299 15.1097047,5.5462053 14.4966562,5.5462053 Z M22.2242463,2.2520467 L13.3931236,2.25615652 L13.3881927,1.10925805 C13.3881927,0.496127668 12.8915592,0 12.2785957,0 C12.0765983,0 11.8873816,0.0542497922 11.7242364,0.148577542 C11.5610062,0.0542497922 11.3717045,0 11.1695088,0 C10.5570554,0 10.0604785,0.496127696 10.0604785,1.10925805 L10.0656928,2.25771543 L3.6930551,2.26066317 C3.60364689,2.23742136 3.50990287,2.22500684 3.41324,2.22500684 C3.31623705,2.22500684 3.22218131,2.23753473 3.13251805,2.26091827 L1.10905858,2.26185361 C0.496605218,2.26185361 0,2.75905835 0,3.37108333 C0,3.98421372 0.496576915,4.48034139 1.10905858,4.48034139 L2.30474819,4.47977452 L2.31285303,21.5945358 L2.31449668,21.5945358 L2.31449668,22.7731225 C2.31449668,23.9983062 3.30765048,24.9916103 4.5325855,24.9916103 L5.64164408,24.9916103 L5.64164408,25 L17.8411185,24.9928857 L17.8411185,24.9916103 L18.9501771,24.9916103 C20.1593559,24.9916103 21.1419961,24.0235604 21.1671324,22.8202013 L21.1580073,6.66195402 C21.1580073,6.048852 20.6614588,5.5527243 20.0489488,5.5527243 C19.4364954,5.5527243 18.9399185,6.048852 18.9399185,6.66195402 L18.9478817,20.7692813 C18.9089161,22.4398859 18.4329414,22.7460259 16.7325983,22.7460259 L17.8839664,22.7743412 L5.29903067,22.7817106 L6.75010756,22.7460259 C5.01332113,22.7460259 4.5538961,22.4268761 4.53286888,20.6601298 L4.54652809,22.7821357 L4.53148029,22.7821357 L4.52280868,4.47869742 L11.0811774,4.47566464 C11.1136818,4.47852735 11.1465545,4.48028466 11.1797957,4.48028466 C11.2134619,4.48028466 11.2467031,4.47852735 11.2796042,4.4755796 L12.1834915,4.47515444 C12.2182062,4.47844232 12.2533177,4.48028463 12.2888826,4.48028463 C12.3248726,4.48028463 12.3604092,4.47841396 12.3955491,4.47506941 L22.2242181,4.47053442 C22.8366714,4.47053442 23.3333333,3.97440672 23.3333333,3.3613047 C23.3333333,2.74817439 22.8366997,2.2520467 22.2242463,2.2520467 Z M19.0154182,20.9535152 L19.0200231,22.7737177 L18.9625901,22.7737177 L19.0154182,20.9535152 Z M8.95144828,5.5462053 C8.33896659,5.5462053 7.8423897,6.04230463 7.8423897,6.65543501 L7.8526766,20.5643566 C7.8526766,21.1764099 8.34925352,21.6736146 8.96176354,21.6736146 C9.5742169,21.6736146 10.0707938,21.1764099 10.0707938,20.5643566 L10.0605069,6.65543501 C10.0604785,6.04233299 9.56390161,5.5462053 8.95144828,5.5462053 Z" id="形状"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <svg onClick={
                                sendAudioHandle
                            } width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                <defs>
                                    <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
                                        <stop stopColor="#00E49F" offset="0%"></stop>
                                        <stop stopColor="#54ADFF" offset="100%"></stop>
                                    </linearGradient>
                                </defs>
                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="02-talk语音3" transform="translate(-244.000000, -415.000000)">
                                        <g id="编组-9" transform="translate(244.000000, 415.000000)">
                                            <circle id="椭圆形备份-4" fill="url(#linearGradient-1)" cx="25" cy="25" r="25"></circle>
                                            <g id="编组备份" transform="translate(12.500000, 12.500000)" fill="#FFFFFF" fillRule="nonzero">
                                                <path d="M23.8050553,8.87714745 C23.1475411,8.87713855 22.6135531,9.40183134 22.6101106,10.0512916 L22.6101106,20.7483624 C22.6101106,21.7722496 21.7698043,22.6022741 20.7332341,22.6022741 L4.26677077,22.6022741 C3.23020049,22.6022741 2.38989425,21.7722496 2.38989425,20.7483624 L2.38989425,10.0512916 C2.38989425,9.39941671 1.85489928,8.87096774 1.19494954,8.87096774 C0.534999794,8.87096774 0,9.39941671 0,10.0512916 L0,20.7483624 C-0.00349885523,23.0834595 1.9028083,24.9830077 4.26677077,25 L20.7144653,25 C23.0843335,24.9897926 25,23.089256 25,20.7483624 L25,10.0512916 C24.9965575,9.40183134 24.4625695,8.87713855 23.8050553,8.87714745 Z" id="路径"></path>
                                                <path d="M9.66981086,17.8369817 L15.5932206,17.8369817 C16.1921744,17.8262012 16.7122592,18.2431141 16.8259802,18.8251923 C16.8761791,19.1604186 16.7764103,19.5006635 16.552685,19.7572203 C16.3289596,20.0137772 16.0034505,20.1612194 15.6610224,20.1611068 L9.76226783,20.1611068 C9.1613845,20.1713566 8.64059892,19.7513049 8.52950825,19.166796 C8.48180171,18.8367024 8.57929251,18.5021991 8.79730381,18.2479556 C9.01531512,17.9937121 9.33295073,17.8440973 9.66981086,17.8369817 L9.66981086,17.8369817 Z M13.5406759,0.0979902832 L18.4717142,5.69175064 C18.5519288,5.7821039 18.5710003,5.91067336 18.52041,6.02003053 C18.4698198,6.1293877 18.3590153,6.19911068 18.2374899,6.1980561 L15.8151174,6.1980561 C15.6617492,6.19691441 15.5318672,6.30971399 15.5130913,6.46035893 C15.3281773,7.75967295 14.2310213,13.5181351 9.03493967,14.3904445 C8.8965206,14.4111979 8.7609156,14.3388601 8.70233868,14.2130201 C8.64376177,14.08718 8.67633185,13.9381693 8.78222396,13.8475386 C10.1383419,12.7524737 10.9969442,11.1671995 11.1676137,9.44329112 C11.2875444,8.47385037 11.34724,7.4980387 11.3463639,6.52135959 C11.3432203,6.353197 11.2079979,6.21669636 11.038174,6.21025623 L8.3754133,6.21025623 C8.25388791,6.21131081 8.14308342,6.14158783 8.09249319,6.03223066 C8.04190296,5.9228735 8.06097447,5.79430403 8.14118898,5.70395077 L13.0722273,0.116290481 C13.1280298,0.0461695557 13.2120684,0.00375828546 13.3021877,0.000237727094 C13.392307,-0.00328283128 13.4794621,0.0324406647 13.5406759,0.0979902832 L13.5406759,0.0979902832 Z" id="形状"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </>

                ) : null}
            </div>

        </div>
    );
})
export default AudioRecorder;